import { z } from 'src/lib'
import { schemaEntityWithIdAndDescription } from 'src/types'

export const PerfilViewFields = {
    BitActivo: 'bitActivo'
} as const

export const PerfilPostFields = {
    Nombre: 'nombre',
    IdPerfil: 'idPerfil'
} as const

export const schemaPerfilViewDTO = z
    .object({
        [PerfilViewFields.BitActivo]: z.boolean()
    })
    .merge(schemaEntityWithIdAndDescription)

export const schemaPerfilPostDTO = z.object({
    [PerfilPostFields.Nombre]: z.string()

    // [PerfilPostFields.IdPerfil]: z.number()
})

export type PerfilPostDTO = z.infer<typeof schemaPerfilPostDTO>

export const PerfilRequestFields = {
    SoloActivos: 'soloActivos',
    DescripcionPerfil: 'descPerfil'
} as const

export const schemaPerfilRequestDTO = z.object({
    [PerfilRequestFields.SoloActivos]: z.boolean().optional(),
    [PerfilRequestFields.DescripcionPerfil]: z.string().optional()
})

export type PerfilRequestDTO = z.infer<typeof schemaPerfilRequestDTO>
